import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaShoppingCart, FaHeart, FaHome } from 'react-icons/fa';

function PostDetail() {
  const { id } = useParams();
  const [notification, setNotification] = React.useState('');

  const posts = {
    1: {
      id: 1,
      title: 'Μεσογειακές Γεύσεις για την Τέλεια Εκδήλωση σας',
      metaTitle: 'Μεσογειακές Γεύσεις για Εκδηλώσεις | Nalumer',
      metaDescription: 'Μεσογειακό μενού catering από το Nalumer: φρέσκα υλικά, ελαιόλαδο και αυθεντικές γεύσεις που μεταμορφώνουν γάμους και εταιρικές εκδηλώσεις σε εμπειρία.',
      date: '15 Ιανουαρίου 2025',
      author: 'Μαρία Παπαδοπούλου',
      image: '/images/1.jpg',
      content: `
        <p>Η μεσογειακή κουζίνα είναι περισσότερο από ένα στυλ μαγειρικής - είναι ένας τρόπος ζωής που γιορτάζει τη φρεσκάδα, την απλότητα και την ποιότητα των υλικών. Όταν πρόκειται για catering εκδηλώσεων, η μεσογειακή προσέγγιση προσφέρει ένα συνδυασμό από υγιεινή διατροφή, εξαιρετική γεύση και οπτική απόλαυση που εντυπωσιάζει κάθε φορά.</p>

        <p>Στο Nalumer, έχουμε αναπτύξει ένα ειδικό μενού εμπνευσμένο από τις καλύτερες μεσογειακές παραδόσεις. Χρησιμοποιούμε φρέσκο ελαιόλαδο extra virgin από τοπικούς παραγωγούς, ώριμες ντομάτες που μυρίζουν καλοκαίρι, φρέσκα αρωματικά βότανα και θαλασσινά που έρχονται κατευθείαν από τις αγορές. Κάθε συστατικό επιλέγεται με μέριμνα για να εξασφαλίσουμε την αυθεντικότητα και την ποιότητα.</p>

        <h3>Τα Βασικά Στοιχεία του Μεσογειακού Μενού</h3>

        <p>Ένα επιτυχημένο μεσογειακό μενού για εκδηλώσεις βασίζεται σε ορισμένα κλειδιά:</p>

        <ul class="custom-list">
          <li>Φρέσκα λαχανικά της εποχής που προσφέρουν χρώμα και γεύση</li>
          <li>Ποιοτικό ελαιόλαδο που ενώνει όλες τις γεύσεις</li>
          <li>Θαλασσινά και ψάρια που μαγειρεύονται με απλές τεχνικές</li>
          <li>Φρέσκα αρωματικά βότανα που προσθέτουν άρωμα και γεύση</li>
          <li>Τυριά και γαλακτοκομικά από τοπικούς παραγωγούς</li>
        </ul>

        <p>Η παρουσίαση είναι εξίσου σημαντική με τη γεύση. Δημιουργούμε πιάτα που μοιάζουν με έργα τέχνης, χρησιμοποιώντας τα φυσικά χρώματα των υλικών για να δημιουργήσουμε οπτικό αντίκτυπο. Από τα βαθυπράσινα των φύλλων ρόκας μέχρι το έντονο κόκκινο των ψητών πιπεριών, κάθε πιάτο είναι μια γιορτή για τα μάτια.</p>

        <h3>Προτάσεις για την Εκδήλωσή σας</h3>

        <p>Για μια επιτυχημένη μεσογειακή εκδήλωση, προτείνουμε να ξεκινήσετε με μια επιλογή από mezze - μικρά πιάτα που επιτρέπουν στους καλεσμένους να δοκιμάσουν διαφορετικές γεύσεις. Χούμους με φρέσκο κυμινοειδές, ντολμαδάκια με αρωματικά βότανα, σαγανάκι τυρί με μέλι και σουσάμι - όλα αυτά δημιουργούν μια πολυαισθητηριακή εμπειρία.</p>

        <p>Για το κύριο γεύμα, μπορείτε να επιλέξετε από ψητά ψάρια με λεμόνι και ελιές, κοτόπουλο μαρινάρισμένο σε μυρωδικά και γιαούρτι, ή χορτοφαγικές επιλογές όπως γεμιστά λαχανικά με ρύζι και βότανα. Κάθε πιάτο συνοδεύεται από φρέσκες σαλάτες και ψωμί που ψήνεται την ίδια μέρα.</p>
      `
    },
    2: {
      id: 2,
      title: 'Τέχνη Παρουσίασης Πιάτων για Εταιρικές Εκδηλώσεις',
      metaTitle: 'Παρουσίαση Πιάτων για Εταιρικά Events | Nalumer',
      metaDescription: 'Μάθετε την τέχνη παρουσίασης πιάτων για εταιρικές εκδηλώσεις. Συμβουλές plating, σερβίτσιο και επαγγελματική εικόνα από την ομάδα catering του Nalumer.',
      date: '12 Ιανουαρίου 2025',
      author: 'Νίκος Αντωνίου',
      image: '/images/2.jpg',
      content: `
        <p>Στον κόσμο του εταιρικού catering, η πρώτη εντύπωση είναι καθοριστική. Η παρουσίαση των πιάτων δεν είναι απλώς μια αισθητική λεπτομέρεια - είναι ένα ισχυρό εργαλείο επικοινωνίας που μεταδίδει την ποιότητα, τον επαγγελματισμό και την προσοχή στη λεπτομέρεια που χαρακτηρίζει την εταιρεία σας.</p>

        <p>Κατά τη διάρκεια των 15 ετών μου ως επαγγελματίας σεφ, έχω μάθει ότι η τέχνη της παρουσίασης πιάτων είναι ένας λεπτός συνδυασμός επιστήμης και δημιουργικότητας. Κάθε στοιχείο στο πιάτο έχει σημασία - από την τοποθέτηση των συστατικών μέχρι την επιλογή του σερβιτσίου και την τελική διακόσμηση.</p>

        <h3>Βασικές Αρχές της Επαγγελματικής Παρουσίασης</h3>

        <ul class="custom-list">
          <li>Η απλότητα είναι κομψότητα - αποφύγετε την υπερφόρτωση του πιάτου</li>
          <li>Το χρώμα προσθέτει ενδιαφέρον - χρησιμοποιήστε φυσικά χρώματα υλικών</li>
          <li>Το ύψος δημιουργεί δραματικότητα - χτίστε πάνω αντί για πλάι</li>
          <li>Ο κενός χώρος είναι σημαντικός - αφήστε το πιάτο να αναπνέει</li>
          <li>Η συνέπεια είναι κλειδί - όλα τα πιάτα πρέπει να είναι πανομοιότυπα</li>
        </ul>

        <p>Για εταιρικές εκδηλώσεις, προτιμάμε το στυλ plating που ονομάζεται architectural - δημιουργούμε δομές που προσελκύουν το βλέμμα και δείχνουν ότι κάθε στοιχείο έχει τοποθετηθεί με σκέψη. Αυτή η προσέγγιση λειτουργεί ιδιαίτερα καλά για επίσημα dinner και εταιρικά events όπου η εικόνα είναι εξίσου σημαντική με τη γεύση.</p>

        <h3>Επιλογή του Κατάλληλου Σερβιτσίου</h3>

        <p>Το πιάτο είναι ο καμβάς σας. Για εταιρικές εκδηλώσεις, συνιστούμε λευκά ή ουδέτερου χρώματος πιάτα που αφήνουν το φαγητό να αστράφτει. Το μέγεθος έχει σημασία - ένα μεγαλύτερο πιάτο επιτρέπει περισσότερο χώρο για την παρουσίαση, αλλά πρέπει να ισορροπείται προσεκτικά με την ποσότητα του φαγητού.</p>

        <p>Οι σύγχρονες τάσεις προτιμούν γεωμετρικά σχήματα - τετράγωνα ή ορθογώνια πιάτα που προσφέρουν μια σύγχρονη αισθητική. Ωστόσο, τα κλασικά στρογγυλά πιάτα παραμένουν διαχρονικά και ταιριάζουν σε κάθε στυλ εκδήλωσης.</p>

        <div class="timeline-section">
          <h3>Εξέλιξη της Παρουσίασης Πιάτων</h3>
          <div class="timeline">
            <div class="timeline-item">
              <h4>1990s - Κλασική Εποχή</h4>
              <p>Μεγάλες μερίδες, παραδοσιακή τοποθέτηση, έμφαση στην ποσότητα</p>
            </div>
            <div class="timeline-item">
              <h4>2000s - Μινιμαλιστική Προσέγγιση</h4>
              <p>Μικρότερες μερίδες, καθαρές γραμμές, λευκός χώρος</p>
            </div>
            <div class="timeline-item">
              <h4>2010s - Αρχιτεκτονικό Στυλ</h4>
              <p>Δημιουργία ύψους, δομές, έμφαση στο οπτικό αποτέλεσμα</p>
            </div>
            <div class="timeline-item">
              <h4>2020s - Φυσική Αισθητική</h4>
              <p>Οργανικές μορφές, βιώσιμα υλικά, έμφαση στα τοπικά προϊόντα</p>
            </div>
          </div>
        </div>

        <p>Σήμερα, η τάση στρέφεται προς μια πιο φυσική αισθητική που υπογραμμίζει την προέλευση των υλικών και τη βιωσιμότητα. Αυτό σημαίνει παρουσιάσεις που δείχνουν τα υλικά στην πιο φυσική τους μορφή, με ελάχιστη επεξεργασία αλλά μέγιστο αντίκτυπο.</p>
      `
    },
    3: {
      id: 3,
      title: 'Οργανικά Υλικά και Βιώσιμο Catering',
      metaTitle: 'Οργανικά Υλικά και Βιώσιμο Catering | Nalumer',
      metaDescription: 'Βιώσιμο catering με οργανικά υλικά από το Nalumer: τοπικοί παραγωγοί, ηθικές πρακτικές και γεύση υψηλής ποιότητας για υπεύθυνες εκδηλώσεις.',
      date: '10 Ιανουαρίου 2025',
      author: 'Ελένη Κωνσταντίνου',
      image: '/images/3.jpg',
      content: `
        <p>Η βιωσιμότητα δεν είναι πια μια τάση - είναι μια αναγκαιότητα. Στο Nalumer, έχουμε κάνει τη δέσμευση να λειτουργούμε με τρόπο που σέβεται το περιβάλλον, υποστηρίζει τους τοπικούς παραγωγούς και προσφέρει στους πελάτες μας τα πιο υγιεινά και νόστιμα προϊόντα.</p>

        <p>Η χρήση οργανικών υλικών δεν σημαίνει απλώς την επιλογή προϊόντων χωρίς χημικά - είναι μια ολοκληρωμένη φιλοσοφία που επηρεάζει κάθε πτυχή της δουλειάς μας. Από την επιλογή των προμηθευτών μέχρι τον τρόπο που προετοιμάζουμε και παρουσιάζουμε το φαγητό, κάθε απόφαση λαμβάνεται με γνώμονα τη βιωσιμότητα.</p>

        <h3>Γιατί να Επιλέξετε Οργανικό Catering</h3>

        <ul class="custom-list">
          <li>Ανώτερη γεύση - τα οργανικά προϊόντα έχουν πλουσιότερη γεύση</li>
          <li>Υγιεινότερες επιλογές - χωρίς φυτοφάρμακα και χημικά πρόσθετα</li>
          <li>Υποστήριξη τοπικής οικονομίας - συνεργασία με μικρούς παραγωγούς</li>
          <li>Περιβαλλοντική ευθύνη - μείωση του αποτυπώματος άνθρακα</li>
          <li>Ζωική ευημερία - υποστήριξη ηθικής κτηνοτροφίας</li>
        </ul>

        <p>Όταν χρησιμοποιούμε οργανικά λαχανικά, η διαφορά είναι αμέσως αισθητή. Οι ντομάτες έχουν πραγματική γεύση ντομάτας, τα πράσινα φύλλα είναι τραγανά και γεμάτα ζωή, τα μυρωδικά αποπνέουν έντονα αρώματα. Αυτή η ποιότητα μεταφράζεται απευθείας στο πιάτο.</p>

        <h3>Η Αλυσίδα Εφοδιασμού μας</h3>

        <p>Έχουμε αναπτύξει μακροχρόνιες σχέσεις με τοπικούς βιολογικούς καλλιεργητές και παραγωγούς. Κάθε εβδομάδα επισκεπτόμαστε αγορές και φάρμες για να επιλέξουμε τα πιο φρέσκα προϊόντα της εποχής. Αυτή η άμεση σχέση με τους παραγωγούς εξασφαλίζει όχι μόνο την ποιότητα αλλά και τη διαφάνεια - ξέρουμε ακριβώς από πού προέρχεται κάθε συστατικό.</p>

        <p>Για το κρέας και τα πουλερικά, συνεργαζόμαστε με φάρμες που ακολουθούν πρακτικές ελεύθερης βοσκής και σεβασμού της ζωικής ευημερίας. Τα ψάρια μας προέρχονται από βιώσιμη αλιεία, πιστοποιημένη από διεθνείς οργανισμούς. Αυτές οι επιλογές ενδέχεται να κοστίζουν περισσότερο, αλλά η διαφορά στη γεύση και την ποιότητα το αξίζει.</p>

        <h3>Μείωση Απορριμμάτων και Ανακύκλωση</h3>

        <p>Η βιωσιμότητα επεκτείνεται και πέρα από τα υλικά. Έχουμε υιοθετήσει πρακτικές μηδενικών αποβλήτων στην κουζίνα μας. Τα υπολείμματα λαχανικών γίνονται ζωμοί, οι φλούδες εσπεριδοειδών μετατρέπονται σε αρωματικά έλαια, το ψωμί της προηγούμενης μέρας γίνεται breadcrumbs.</p>

        <p>Για τις εκδηλώσεις, χρησιμοποιούμε σερβίτσια και μαχαιροπήρουνα από βιοδιασπώμενα υλικά ή επαναχρησιμοποιήσιμα πιάτα. Συνεργαζόμαστε με οργανισμούς που συλλέγουν το περίσσευμα φαγητό για δωρεά σε άτομα που έχουν ανάγκη.</p>

        <div class="timeline-section">
          <h3>Η Πορεία μας προς τη Βιωσιμότητα</h3>
          <div class="timeline">
            <div class="timeline-item">
              <h4>2018 - Πρώτα Βήματα</h4>
              <p>Εισαγωγή οργανικών προϊόντων στο 30% του μενού μας</p>
            </div>
            <div class="timeline-item">
              <h4>2020 - Επέκταση</h4>
              <p>Συνεργασία με 15 τοπικούς βιολογικούς παραγωγούς</p>
            </div>
            <div class="timeline-item">
              <h4>2022 - Πιστοποίηση</h4>
              <p>Απόκτηση πιστοποίησης Βιολογικού Catering</p>
            </div>
            <div class="timeline-item">
              <h4>2025 - Σήμερα</h4>
              <p>90% οργανικά υλικά, μηδενικά απόβλητα στις εκδηλώσεις μας</p>
            </div>
          </div>
        </div>

        <p>Το ταξίδι προς τη βιωσιμότητα είναι συνεχές. Κάθε μήνα αξιολογούμε τις πρακτικές μας και αναζητούμε νέους τρόπους να βελτιώσουμε το περιβαλλοντικό μας αποτύπωμα. Πιστεύουμε ότι το καλό φαγητό και η φροντίδα για τον πλανήτη πηγαίνουν χέρι-χέρι.</p>
      `
    },
    4: {
      id: 4,
      title: 'Μενού για Γάμους: Από την Παράδοση στη Σύγχρονη Κουζίνα',
      metaTitle: 'Μενού Γάμου: Παράδοση και Σύγχρονη Κουζίνα | Nalumer',
      metaDescription: 'Γαμήλιο μενού από το Nalumer: ελληνική παράδοση με σύγχρονες τεχνικές, δοκιμαστικά γεύματα και επιλογές για όλους τους καλεσμένους σας.',
      date: '8 Ιανουαρίου 2025',
      author: 'Δημήτρης Γεωργίου',
      image: '/images/4.jpg',
      content: `
        <p>Ο γάμος είναι μια από τις πιο σημαντικές στιγμές στη ζωή ενός ζευγαριού, και το γαμήλιο τραπέζι παίζει καθοριστικό ρόλο στη δημιουργία αξέχαστων αναμνήσεων. Στο Nalumer, έχουμε την τιμή να συμμετέχουμε σε αυτή την ξεχωριστή μέρα, δημιουργώντας μενού που συνδυάζουν την παραδοσιακή ελληνική φιλοξενία με σύγχρονες γαστρονομικές τεχνικές.</p>

        <p>Κατά τη διάρκεια των ετών, έχουμε υπηρετήσει εκατοντάδες γάμους, από μικρές οικογενειακές συγκεντρώσεις μέχρι μεγάλες εκδηλώσεις με εκατοντάδες καλεσμένους. Κάθε γάμος είναι μοναδικός και το μενού πρέπει να αντικατοπτρίζει την προσωπικότητα και τις προτιμήσεις του ζευγαριού.</p>

        <h3>Σχεδιασμός του Τέλειου Γαμήλιου Μενού</h3>

        <ul class="custom-list">
          <li>Ξεκινήστε με δοκιμαστικό γεύμα - δοκιμάστε πριν αποφασίσετε</li>
          <li>Λάβετε υπόψη διαιτητικούς περιορισμούς - προσφέρετε επιλογές για όλους</li>
          <li>Ισορροπήστε την παράδοση με την καινοτομία</li>
          <li>Επιλέξτε υλικά της εποχής για φρεσκάδα</li>
          <li>Συντονίστε το μενού με το θέμα του γάμου</li>
        </ul>

        <p>Ένα τυπικό γαμήλιο μενού στο Nalumer ξεκινά με μια επιλογή από ορεκτικά που σερβίρονται κατά την υποδοχή. Μικρά canapés, μπουκίτσες που τρώγονται με ένα δάγκωμα, και finger food που επιτρέπει στους καλεσμένους να κοινωνικοποιηθούν ενώ απολαμβάνουν τη γεύση.</p>

        <h3>Παραδοσιακά Πιάτα με Σύγχρονη Ματιά</h3>

        <p>Η ελληνική κουζίνα έχει μια πλούσια παράδοση που εκτείνεται αιώνες πίσω. Πιάτα όπως το μοσχάρι κοκκινιστό, το αρνάκι στη λαδόκολλα, ο γιουβέτσι με κριθαράκι - όλα αυτά είναι κλασικά που οι Έλληνες αγαπούν. Η πρόκλησή μας είναι να πάρουμε αυτές τις παραδοσιακές συνταγές και να τις παρουσιάσουμε με σύγχρονο τρόπο.</p>

        <p>Για παράδειγμα, παίρνουμε το κλασικό μοσχάρι κοκκινιστό και το σερβίρουμε σε μικρές μερίδες με πουρέ σελινόριζας και τραγανό κρεμμύδι. Το αποτέλεσμα είναι ένα πιάτο που σέβεται την παράδοση αλλά έχει σύγχρονη αισθητική και γεύση.</p>

        <h3>Εναλλακτικά Μενού</h3>

        <p>Όλο και περισσότερα ζευγάρια ζητούν χορτοφαγικές ή vegan επιλογές για τους καλεσμένους τους. Έχουμε αναπτύξει μια εκτενή σειρά από φυτικά πιάτα που είναι εξίσου εντυπωσιακά με τα παραδοσιακά. Ρισότο με μανιτάρια και τρούφα, λαζάνια με λαχανικά ψητά στη σχάρα, moussaka με φακές αντί για κιμά - αυτές οι επιλογές δείχνουν ότι η φυτική κουζίνα μπορεί να είναι εξίσου πολυτελής.</p>

        <div class="timeline-section">
          <h3>Εξέλιξη των Γαμήλιων Μενού</h3>
          <div class="timeline">
            <div class="timeline-item">
              <h4>Παραδοσιακή Εποχή</h4>
              <p>Μεγάλες μερίδες, παραδοσιακά πιάτα, έμφαση στην αφθονία</p>
            </div>
            <div class="timeline-item">
              <h4>Μοντέρνα Προσέγγιση</h4>
              <p>Fusion κουζίνα, διεθνείς επιρροές, καινοτόμες παρουσιάσεις</p>
            </div>
            <div class="timeline-item">
              <h4>Σύγχρονη Τάση</h4>
              <p>Τοπικά προϊόντα, βιωσιμότητα, εξατομικευμένα μενού</p>
            </div>
            <div class="timeline-item">
              <h4>Μέλλον</h4>
              <p>Διαδραστικές εμπειρίες, προσωποποιημένα πιάτα, τεχνολογική ενσωμάτωση</p>
            </div>
          </div>
        </div>

        <p>Το επιδόρπιο είναι η κορυφαία στιγμή του γαμήλιου γεύματος. Πέρα από την παραδοσιακή γαμήλια τούρτα, προσφέρουμε dessert tables με ποικιλία από μικρά γλυκά, macaron towers, chocolate fountains και πολλά άλλα. Κάθε επιδόρπιο δημιουργείται με μέριμνα και αγάπη.</p>

        <p>Στο τέλος της ημέρας, ένα επιτυχημένο γαμήλιο μενού είναι αυτό που κάνει τους καλεσμένους να νιώθουν ευπρόσδεκτοι, να απολαμβάνουν τη γεύση και να δημιουργούν όμορφες αναμνήσεις. Αυτό είναι το στόχος μας σε κάθε γάμο που υπηρετούμε.</p>
      `
    },
    5: {
      id: 5,
      title: 'Σεζόν Εορτών: Ιδέες Catering για Χειμερινές Εκδηλώσεις',
      metaTitle: 'Ιδέες Catering για Χειμερινές Εκδηλώσεις | Nalumer',
      metaDescription: 'Χειμερινό catering από το Nalumer: ζεστά πιάτα, εορταστική ατμόσφαιρα και ιδέες για Χριστούγεννα, Πρωτοχρονιά και εταιρικά winter events.',
      date: '5 Ιανουαρίου 2025',
      author: 'Σοφία Μιχαηλίδου',
      image: '/images/5.jpg',
      content: `
        <p>Ο χειμώνας φέρνει μια μαγική ατμόσφαιρα που είναι ιδανική για εορταστικές εκδηλώσεις. Από εταιρικά Christmas parties μέχρι οικογενειακές συγκεντρώσεις για την Πρωτοχρονιά, η χειμερινή περίοδος είναι γεμάτη από ευκαιρίες να γιορτάσουμε με αγαπημένα μας πρόσωπα γύρω από ένα ζεστό και νόστιμο τραπέζι.</p>

        <p>Στο Nalumer, λατρεύουμε τη χειμερινή σεζόν γιατί μας δίνει την ευκαιρία να δημιουργήσουμε μενού που είναι ζεστά, παρηγορητικά και γεμάτα από τις γεύσεις της εποχής. Τα χειμερινά υλικά - ριζικά λαχανικά, μανιτάρια, άγρια πουλερικά, εσπεριδοειδή - προσφέρουν ένα πλούσιο παλέτο γεύσεων που εμπνέει δημιουργικότητα.</p>

        <h3>Ιδέες για Χειμερινά Μενού</h3>

        <ul class="custom-list">
          <li>Σούπες και ζωμοί - ζεστασιά σε κάθε γουλιά</li>
          <li>Ψητά κρέατα - από αρνί μέχρι χοιρινό με χειμερινά μπαχαρικά</li>
          <li>Λαχανικά του χειμώνα - κολοκύθα, παντζάρι, γλυκοπατάτα</li>
          <li>Ζεστά επιδόρπια - apple crumble, σοκολατένιες τούρτες</li>
          <li>Εορταστικά ποτά - mulled wine, hot chocolate με μπαχαρικά</li>
        </ul>

        <p>Ένα από τα αγαπημένα μας χειμερινά πιάτα είναι το κοκκινιστό αρνί με κυδώνι και κανέλα. Το κρέας μαγειρεύεται αργά μέχρι να γίνει τόσο τρυφερό που λιώνει στο στόμα, ενώ το κυδώνι προσθέτει μια γλυκιά και αρωματική νότα που ισορροπεί τέλεια με τη γήινη γεύση του αρνιού.</p>

        <h3>Διακόσμηση και Ατμόσφαιρα</h3>

        <p>Η χειμερινή διακόσμηση είναι εξίσου σημαντική με το φαγητό. Χρησιμοποιούμε φυσικά στοιχεία όπως κλαδιά έλατου, κουκουνάρια, και εποχιακά άνθη για να δημιουργήσουμε μια ζεστή και φιλόξενη ατμόσφαιρα. Τα κεριά σε διάφορα ύψη προσθέτουν ρομαντικό φως, ενώ οι χρυσές και χάλκινες λεπτομέρειες δίνουν μια πινελιά πολυτέλειας.</p>

        <p>Για τα food stations, δημιουργούμε θεματικές γωνιές - ένα σταθμό με ζεστές σούπες σε κούπες, ένα dessert bar με χειμερινά γλυκά, ένα hot chocolate station με διάφορα toppings. Αυτές οι διαδραστικές στιγμές δίνουν στους καλεσμένους την ευκαιρία να εξερευνήσουν και να απολαύσουν το φαγητό με το δικό τους ρυθμό.</p>

        <h3>Εορταστικές Συνταγές που Αγαπάμε</h3>

        <p>Το χειμώνα, προτιμάμε να χρησιμοποιούμε μπαχαρικά που ζεσταίνουν το σώμα και την καρδιά - κανέλα, γλυκάνισο, γαρύφαλλο, τζίντζερ. Αυτά τα αρώματα όχι μόνο προσθέτουν βάθος στη γεύση αλλά δημιουργούν και μια νοσταλγική ατμόσφαιρα που μας θυμίζει οικογενειακές γιορτές.</p>

        <p>Μια από τις πιο δημοφιλείς συνταγές μας είναι το χοιρινό με μήλα και θυμάρι. Το χοιρινό ψήνεται αργά μέχρι να αποκτήσει μια τραγανή εξωτερική κρούστα, ενώ το εσωτερικό παραμένει ζουμερό. Τα καραμελωμένα μήλα και το φρέσκο θυμάρι προσθέτουν μια γλυκιά και αρωματική διάσταση που είναι απλά εθιστική.</p>

        <div class="timeline-section">
          <h3>Εορταστικός Χρονοδιάγραμμα</h3>
          <div class="timeline">
            <div class="timeline-item">
              <h4>Νοέμβριος - Προετοιμασία</h4>
              <p>Σχεδιασμός μενού, κρατήσεις, επιλογή διακοσμητικών</p>
            </div>
            <div class="timeline-item">
              <h4>Δεκέμβριος - Κορυφαία Σεζόν</h4>
              <p>Εταιρικά parties, οικογενειακές συγκεντρώσεις, γιορτινά events</p>
            </div>
            <div class="timeline-item">
              <h4>Πρωτοχρονιά - Celebration</h4>
              <p>Μεγάλες εκδηλώσεις, gala dinners, midnight feasts</p>
            </div>
            <div class="timeline-item">
              <h4>Ιανουάριος - Συνέχεια</h4>
              <p>Πιο ήρεμες αλλά εξίσου όμορφες χειμερινές εκδηλώσεις</p>
            </div>
          </div>
        </div>

        <h3>Συμβουλές για μια Επιτυχημένη Χειμερινή Εκδήλωση</h3>

        <p>Προγραμματίστε νωρίς - η χειμερινή σεζόν είναι πολυάσχολη και οι διαθέσιμες ημερομηνίες γεμίζουν γρήγορα. Επιλέξτε μενού που μπορούν να προετοιμαστούν εν μέρει εκ των προτέρων για να μειώσετε το στρες την ημέρα της εκδήλωσης.</p>

        <p>Σκεφτείτε τη ροή - σε μια χειμερινή εκδήλωση, οι καλεσμένοι εκτιμούν τις θερμές γωνίες και τις ζεστές εναλλαγές. Δημιουργήστε stations που προσφέρουν ποικιλία και κρατούν το ενδιαφέρον ζωντανό όλο το βράδυ.</p>

        <p>Μην ξεχνάτε τα drinks - τα χειμερινά ποτά είναι εξίσου σημαντικά. Mulled wine με πορτοκάλι και μπαχαρικά, hot toddy με μέλι και λεμόνι, και σοκολάτα με marshmallows είναι όλα hits που ζεσταίνουν την καρδιά.</p>

        <p>Η χειμερινή σεζόν είναι μια μαγική περίοδος για εκδηλώσεις. Με το σωστό μενού, διακόσμηση και ατμόσφαιρα, μπορείτε να δημιουργήσετε μια εμπειρία που οι καλεσμένοι σας θα θυμούνται για χρόνια.</p>
      `
    }
  };

  const post = posts[id];

  const handleShare = () => {
    setNotification('Η λειτουργία κοινοποίησης θα είναι σύντομα διαθέσιμη');
    setTimeout(() => setNotification(''), 3000);
  };

  const handleFavorite = () => {
    setNotification('Το άρθρο προστέθηκε στα αγαπημένα σας');
    setTimeout(() => setNotification(''), 3000);
  };

  if (!post) {
    return <div>Το άρθρο δεν βρέθηκε</div>;
  }

  return (
    <>
      <Helmet>
        <title>{post.metaTitle}</title>
        <meta name="description" content={post.metaDescription} />
        <meta property="og:title" content={post.metaTitle} />
        <meta property="og:description" content={post.metaDescription} />
        <meta property="og:image" content={`https://nalumer.com${post.image}`} />
        <meta property="og:url" content={`https://nalumer.com/post/${post.id}`} />
        <link rel="canonical" href={`https://nalumer.com/post/${post.id}`} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "headline": post.title,
            "image": `https://nalumer.com${post.image}`,
            "datePublished": "2025-01-15",
            "author": {
              "@type": "Person",
              "name": post.author
            },
            "publisher": {
              "@type": "Organization",
              "name": "Nalumer",
              "logo": {
                "@type": "ImageObject",
                "url": "https://nalumer.com/images/logo.png"
              }
            }
          })}
        </script>
      </Helmet>

      <div className="post-detail-container">
        <Link to="/" className="back-button">
          <FaHome />
          Επιστροφή στην Αρχική
        </Link>

        <article className="post-detail">
          <img src={post.image} alt={post.title} className="post-detail-image" />
          
          <div className="post-detail-content">
            <h1>{post.title}</h1>
            
            <div className="post-detail-meta">
              <span>{post.date}</span>
              <span>{post.author}</span>
            </div>

            <div className="post-detail-text" dangerouslySetInnerHTML={{ __html: post.content }} />

            <div className="post-card-actions">
              <button onClick={handleShare} className="btn btn-primary">
                <FaShoppingCart />
                Κοινοποίηση
              </button>
              <button onClick={handleFavorite} className="btn btn-outline">
                <FaHeart />
                Αγαπημένα
              </button>
            </div>
          </div>
        </article>
      </div>

      {notification && (
        <div className="notification">
          <p>{notification}</p>
        </div>
      )}
    </>
  );
}

export default PostDetail;